import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { TenantConfig } from '../types/tenant.types';

interface TenantStore {
  // State
  tenant: TenantConfig | null;
  isLoaded: boolean;
  isLoading: boolean;
  error: string | null;

  // Actions
  setTenant: (tenant: TenantConfig) => void;
  setLoading: (loading: boolean) => void;
  setError: (error: string | null) => void;
  reset: () => void;
}

export const useTenantStore = create<TenantStore>()(
  persist(
    (set) => ({
      // Initial state
      tenant: null,
      isLoaded: false,
      isLoading: false,
      error: null,

      // Actions
      setTenant: (tenant) =>
        set({
          tenant,
          isLoaded: true,
          isLoading: false,
          error: null,
        }),

      setLoading: (loading) => set({ isLoading: loading }),

      setError: (error) =>
        set({
          error,
          isLoading: false,
        }),

      reset: () =>
        set({
          tenant: null,
          isLoaded: false,
          isLoading: false,
          error: null,
        }),
    }),
    {
      name: 'dms-tenant-storage',
      partialize: (state) => ({ tenant: state.tenant }), // Only persist tenant data
    }
  )
);

// Selectors
export const selectTenant = (state: TenantStore) => state.tenant;
export const selectTenantId = (state: TenantStore) => state.tenant?.id;
export const selectTenantName = (state: TenantStore) => state.tenant?.displayName;
export const selectTenantLogo = (state: TenantStore) => state.tenant?.logo;
